import { Dialog, DialogContent } from "@/components/ui/dialog/dialog";
import { useEmpAttendanceModal } from "./use-attendance-modal";
import { CustomizedCalendar } from ".";

export const EmployeeAttendanceModal = () => {
  const { open, onOpenChange } = useEmpAttendanceModal();

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-7xl h-full max-h-[800px]">
          <CustomizedCalendar />
        </DialogContent>
      </Dialog>
    </>
  );
};
